import { useEffect, useState } from 'react';

// Asia/Kuala_Lumpur uses UTC+08:00, without daylight saving time.
const MALAYSIA_OFFSET_MS = 8 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export const getTanTengBooAge = (now = new Date()) => {
    const malaysiaDate = new Date(now.getTime() + MALAYSIA_OFFSET_MS);
    const beforeBirthday = malaysiaDate.getUTCMonth() < 1 ||
        (malaysiaDate.getUTCMonth() === 1 && malaysiaDate.getUTCDate() < 11);
    return malaysiaDate.getUTCFullYear() - 1954 - (beforeBirthday ? 1 : 0);
};

const useTanTengBooAge = () => {
    const [age, setAge] = useState(() => getTanTengBooAge());

    useEffect(() => {
        let timeout;
        const refresh = () => {
            clearTimeout(timeout);
            const now = new Date();
            setAge(getTanTengBooAge(now));
            const untilMidnight = DAY_MS - ((now.getTime() + MALAYSIA_OFFSET_MS) % DAY_MS);
            timeout = setTimeout(refresh, untilMidnight);
        };
        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') refresh();
        };

        refresh();
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => {
            clearTimeout(timeout);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);

    return age;
};

export default useTanTengBooAge;
